"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function VanguardiaTecnolGica() {
  const specs = [{
    number: "SPEC.01",
    label: "VIGILANCIA INTELIGENTE",
    title: "Sistemas de Videovigilancia de Alta Definición",
    description: "Implementamos circuitos cerrados de televisión (CCTV) con analítica avanzada y reconocimiento facial. Nuestra infraestructura permite una supervisión constante con nitidez absoluta, garantizando que ningún detalle pase desapercibido en sus instalaciones.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_cctv_monitoring_center.png",
    alt: "Centro de monitoreo con múltiples pantallas mostrando cámaras de seguridad",
    specs: [{
      k: "RESOLUCIÓN",
      v: "4K ULTRA HD"
    }, {
      k: "ANALÍTICA",
      v: "IA ACTIVA"
    }, {
      k: "ALMACENAMIENTO",
      v: "NUBE + LOCAL"
    }, {
      k: "VISIÓN",
      v: "TÉRMICA/IR"
    }]
  }, {
    number: "SPEC.02",
    label: "RASTREO SATELITAL",
    title: "Geolocalización GPS y Geocercas",
    description: "Control total sobre su flota y activos mediante rastreo satelital en tiempo real. Configuramos perímetros virtuales (geocercas) con alertas instantáneas ante cualquier desviación, asegurando la integridad de sus traslados.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_gps_tracking_interface.png",
    alt: "Interfaz de software de rastreo GPS mostrando rutas vehiculares",
    specs: [{
      k: "PRECISIÓN",
      v: "< 2 METROS"
    }, {
      k: "ACTUALIZACIÓN",
      v: "CADA 10 SEG"
    }, {
      k: "COBERTURA",
      v: "NACIONAL"
    }, {
      k: "ALERTAS",
      v: "PUSH / SMS"
    }]
  }, {
    number: "SPEC.03",
    label: "CONTROL DE ACCESO",
    title: "Autenticación Biométrica y Encriptada",
    description: "Gestionamos el flujo de personal mediante tecnologías de vanguardia: lectores de huella, reconocimiento de iris y tarjetas NFC encriptadas. Seguridad perimetral robusta que impide el acceso no autorizado de manera definitiva.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_biometric_access_panel.webp",
    alt: "Panel de control de acceso biométrico en una entrada corporativa",
    specs: [{
      k: "MÉTODO",
      v: "BIOMETRÍA + NFC"
    }, {
      k: "TIEMPO RESP.",
      v: "0.3 SEG"
    }, {
      k: "REGISTRO",
      v: "AUDITABLE"
    }, {
      k: "CAPACIDAD",
      v: "ILIMITADA"
    }]
  }, {
    number: "SPEC.04",
    label: "CENTRO DE COMANDO",
    title: "Monitoreo 24/7 y Respuesta Inmediata",
    description: "Nuestra Central de Emergencias opera sin interrupciones, coordinando unidades de reacción y manteniendo comunicación directa con autoridades. La tecnología y la disciplina humana se unen para una protección total.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_command_center_operators.png",
    alt: "Operadores de seguridad en una central de comando tecnológica",
    specs: [{
      k: "DISPONIBILIDAD",
      v: "24 / 7 / 365"
    }, {
      k: "REACCIÓN",
      v: "INMEDIATA"
    }, {
      k: "PROTOCOLOS",
      v: "CERTIFICADOS"
    }, {
      k: "ENLACE",
      v: "DIRECTO C5"
    }]
  }, {
    number: "SPEC.05",
    label: "INFRAESTRUCTURA MÓVIL",
    title: "Unidades de Patrullaje Equipadas",
    description: "Nuestras unidades cuentan con sistemas de comunicación redundante y telemetría avanzada. Cada vehículo es un nodo tecnológico capaz de responder ante cualquier contingencia con eficiencia y rapidez.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_security_patrol_vehicle.png",
    alt: "Vehículo de patrullaje de Poseidón con equipamiento tecnológico",
    specs: [{
      k: "COMUNICACIÓN",
      v: "RADIO + LTE"
    }, {
      k: "TELEMETRÍA",
      v: "EN VIVO"
    }, {
      k: "EQUIPAMIENTO",
      v: "PRIMEROS AUX."
    }, {
      k: "BLINDAJE",
      v: "OPCIONAL"
    }]
  }];
  return <section data-section-id="2349" id="vanguardia-tecnológica" className="bg-background text-foreground py-24 md:py-[140px] px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="font-mono text-xs tracking-widest text-primary mb-10">
          [ TECNOLOGÍA / 05 ]
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-20 md:mb-28">
          <div className="lg:col-span-7">
            <h2 className="font-default font-semibold tracking-tight text-4xl md:text-5xl lg:text-[64px] leading-[1.02] text-foreground">
              Vanguardia Tecnológica
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="font-default text-base md:text-lg leading-relaxed text-muted-foreground">
              En Grupo Poseidón, la seguridad se fundamenta en la precisión técnica. 
              Integramos herramientas de última generación con protocolos de 
              disciplina corporativa para crear un ecosistema de protección 
              infalible, medible y transparente para nuestros clientes.
            </p>
          </div>
        </div>

        {}
        <div className="border-t border-border">
          {specs.map((spec, i) => {
          const imageLeft = i % 2 === 0;
          return <div key={i} data-index={i}>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 py-16 md:py-20 items-center">
                  {}
                  <div className={`relative overflow-hidden rounded-md bg-card border border-border shadow-md ${imageLeft ? "lg:order-1" : "lg:order-2"}`}>
                    <div className="aspect-[4/3] w-full">
                      <img src={spec.image} data-wvc-srcset={`${spec.image}-wvc-srcset`} data-wvc-sizes={`${spec.image}-wvc-sizes`} alt={spec.alt} loading="lazy" decoding="async" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" />
                    </div>
                    {}
                    <div className="absolute top-4 left-4 font-mono text-[10px] tracking-widest text-foreground/80 bg-background/70 backdrop-blur-sm px-2 py-1 rounded-md border border-border">
                      {spec.number}
                    </div>
                  </div>

                  {}
                  <div className={`${imageLeft ? "lg:order-2" : "lg:order-1"} flex flex-col`}>
                    <div className="font-mono text-xs tracking-widest text-primary mb-5">
                      {spec.number} / {spec.label}
                    </div>
                    <h3 className="font-default font-semibold tracking-tight text-2xl md:text-3xl leading-tight text-foreground mb-5">
                      {spec.title}
                    </h3>
                    <p className="font-default text-base leading-relaxed text-muted-foreground mb-8">
                      {spec.description}
                    </p>

                    {}
                    <div className="grid grid-cols-2 gap-x-8 gap-y-3 border-t border-border pt-6">
                      {spec.specs.map((row, j) => <div key={j} data-index={j} className="flex items-baseline justify-between gap-3 border-b border-border/60 pb-3">
                          <span className="font-mono text-[10px] tracking-widest text-muted-foreground uppercase">
                            {row.k}
                          </span>
                          <span className="font-mono text-xs text-foreground font-semibold">
                            {row.v}
                          </span>
                        </div>)}
                    </div>
                  </div>
                </div>

                {}
                {i < specs.length - 1 && <div className="relative border-t border-border">
                    <div className="absolute -top-2.5 left-0 bg-background pr-4">
                      <span className="font-mono text-[10px] tracking-widest text-muted-foreground">
                        {specs[i + 1].number} →
                      </span>
                    </div>
                  </div>}
              </div>;
        })}
          <div className="border-t border-border" />
        </div>

        {}
        <div className="flex justify-center mt-20 md:mt-24">
          <Button variant="ghost" size="lg" className="font-mono text-sm tracking-wider text-foreground border border-border hover:bg-primary hover:text-primary-foreground px-8 rounded-md transition-all">
            Descargar Ficha Técnica de Seguridad (PDF)
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>;
}